import { PolicyInputProps } from '../PolicyInput';

import { useResource } from '../Resource/ResourceProvider';
import {
  DAY_HOUR_PRESETS,
  DurationPresetInput,
  RffControlsProvider,
} from '@cast/shared-rff-ui';

import { Stack } from '@cast/design-system';

type LookbackFieldProps = Pick<PolicyInputProps, 'LabelComponent'>;

export const LookbackField = ({ LabelComponent }: LookbackFieldProps) => {
  const { useDisabledResource } = useResource();
  const isCpuDisabled = useDisabledResource('cpu');
  const isMemoryDisabled = useDisabledResource('memory');

  return (
    <Stack gap={24} data-testid="lookback-field">
      <RffControlsProvider namePrefix="cpu">
        <DurationPresetInput
          units={['days', 'hours']}
          presets={DAY_HOUR_PRESETS}
          disabled={isCpuDisabled}
          label="CPU"
          LabelComponent={LabelComponent}
          testId="lookback-cpu-section"
        />
      </RffControlsProvider>

      <RffControlsProvider namePrefix="memory">
        <DurationPresetInput
          units={['days', 'hours']}
          presets={DAY_HOUR_PRESETS}
          disabled={isMemoryDisabled}
          label="Memory"
          LabelComponent={LabelComponent}
          testId="lookback-memory-section"
        />
      </RffControlsProvider>
    </Stack>
  );
};
